import React, { useState, useEffect, useRef } from "react"
import styled from "styled-components"
import { Spacer, WebView } from "../styles/common"
import { navigate } from "gatsby"
import { useQuery } from "@apollo/react-hooks"
import withApolloClient from "./withApolloClient"
import { getShoppingCartQueryGQL } from "../components/gql/cart"
// import { getDeviceId, inBrowser, decodeUserToken } from "@omnichannel/ace-b2b-elements"
// import { inBrowser } from "../utils/utils"
// import decodeUserToken from "../helpers/decodeUserToken"
import { InfoCircle } from "styled-icons/boxicons-regular/InfoCircle"
import {
  NotificationCard,
  RoundedButton,
  // Bag,
  CheckAlt,
  Close,
  theme,
  getDeviceId, inBrowser, decodeUserToken
} from "@omnichannel/ace-b2b-elements"
import useOutsideAlerter from "../helpers/useOutsideAlerter"
import CartPopCheckout from "./basket/cartPopCheckout"
import { ShoppingCart } from "styled-icons/material/ShoppingCart"
import { APP_ID } from "../helpers/constants"

const MainContainer = styled.div`
  display: flex;
  position: relative;
  flex-direction: row;
  align-items: center;
  padding-right: 1rem;
  .react-tooltip {
    opacity: 1 !important;
    margin-left: -25rem !important;
  }
  .__react_component_tooltip.place-bottom {
    $tip-offset: -$tooltip-offset - 8px;
    &::before {
      margin-left: $tip-offset;
    }

    &::before {
      margin-left: 24.8rem;
    }
    &::after {
      margin-left: 25rem;
    }
  }
  .react-tooltip .basket-list,
  .react-tooltip .basket-summary {
    width: 100% !important;
  }
`

const HeaderWebView = styled.div`
  display: inherit;
  @media (max-width: 1023px) {
    display: none;
  }
`

const HeaderButton = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  justify-content: center;
  position: relative;
`

// const YourBasket = styled.div`
//   font-size: 1.5rem;
//   font-weight: 700;
// `

const Text = styled.div`
  color: #fff;
  font-size: 1.2rem;
  font-weight: 700;
  align-self: center;
`

// const YourBasketText = styled(Text)`
//   margin-right: 0.8rem;
// `

const ShoppingCartCount = styled.div`
  visibility: ${props => (props.hasData ? "visible" : "hidden")};
  padding: 0rem .4rem;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  text-align: center;
  border-radius: 2rem;
  font-size: 1.2rem;
  font-weight: 500;
  color: #c2171d;
  position: relative; 
  top: -.7rem;
  border: .2rem solid #E8171E;
`

// const MobileShoppingCartCount = styled.div`
//   visibility: ${props => (props.hasData ? "visible" : "hidden")};
//   width: 2.1rem;
//   height: 2.1rem;
//   background: ${props => props.theme.default.secondaryPomegranate};
//   text-align: center;
//   border-radius: 2rem;
//   font-size: 1.2rem;
//   font-weight: 600;
//   color: #fff;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   position: absolute;
//   top: -0.8rem;
//   left: 1.1rem;
//   @media (min-width: 1024px) {
//     display: none;
//   }
// `

const CartPop = styled.div`
  display: block;
  position: absolute;
  padding: 1rem 2rem 2rem 2rem;
  width: 57.5rem;
  top: 6rem;
  right: 0;
  z-index: 200;
  border-radius: 0.2rem;
  background-color: #fff;
  box-shadow: 0px 1px 6px rgba(0, 0, 0, 0.5);
  @media (max-width: 767px) {
    width: 95%;
    margin: auto;
    position: relative;
  }
  @media (max-width: 960px) {
    top: 7.4rem;
  }
`

const TopPointer = styled.div`
  width: 0;
  height: 0;
  position: absolute;
  right: 4.4rem;
  top: 2rem;
  margin-left: 17rem;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 10px solid #fff;
  z-index: 250;
  @media (max-width: 1023px) {
    right: 0.7rem;
  }
`

const CartPopContainer = styled.div`
  visibility: ${props => (props.show ? "visible" : "hidden")};
  opacity: ${props => (props.show ? 1 : 0)};
  max-width: 140rem;
  margin: auto;
  right: 0;
  position: absolute;
  width: 100%;
  transition: ${props =>
    props.show
      ? "visibility 0s, opacity 0.5s linear;"
      : "opacity 0.5s linear, visibility 0s 1s"};
  -webkit-transition: ${props =>
    props.show
      ? "visibility 0s, opacity 0.5s linear;"
      : "opacity 0.5s linear, visibility 0s 1s"};
  -ms-transition: ${props =>
    props.show
      ? "visibility 0s, opacity 0.5s linear;"
      : "opacity 0.5s linear, visibility 0s 1s"};
  -o-transition: ${props =>
    props.show
      ? "visibility 0s, opacity 0.5s linear;"
      : "opacity 0.5s linear, visibility 0s 1s"};
  @media (max-width: 767px) {
    position: fixed;
    top: 10%;
    width: 100%;
    left: 0;
    z-index: 200;
  }
`

const TopMessage = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`

const Message = styled.div`
  font-size: 1.4rem;
  color: #3e3f42;
  letter-spacing: 0.4px;
  line-height: 2.2rem;
  display: flex;
  flex-direction: row;
  align-items: center;
`

const NotificationDetails = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  @media (max-width: 767px) {
    flex-direction: column;
  }
`

const ButtonText = styled.div`
  font-size: 1.4rem;
  color: ${props => (props.color ? props.color : "#3e3f42")};
  letter-spacing: 0.4px;
  text-align: center;
  white-space: nowrap;
  padding: 0 4rem;
  margin: 0 1rem;
  @media (max-width: 767px) {
    padding: 0 2rem;
  }
`

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 15.4rem;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 0rem;
  margin: 0rem 1rem 0rem 1.5rem;
  
  @media (max-width: 767px) {
    padding: 1rem;
    max-width: 100%;
    flex-direction: row;
    align-items: space-between;
    justify-content: space-between;
    margin: 0rem 1rem;
  }
`

const Button = styled.div`
  flex: 1;
  width: 100%;
  @media (max-width: 767px) {
    max-width: 15.4rem;
  }
`

const CloseButton = styled.div`
  padding: 1rem 0;
  cursor: pointer;
`

const ItemCards = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 60vh;
  overflow-y: auto;
`

const Item = styled.div`
  padding-bottom: 1rem;
`

const ShoppingCartSubtotal = styled.div`
  font-size: 1.4rem;
  color: #fff;
  
  font-weight: 500;
  @media (max-width: 767px) {
    font-size: 1.6rem;
    padding-left: 1rem;
    font-weight: 500;
  }
`

let deviceId = undefined
if (inBrowser) {
  getDeviceId().then(result => {
    deviceId = result
  })
}

const BasketHeader = () => {
  return (
    <React.Fragment>
      <div
        style={{
          marginTop: "1rem",
          display: "flex",
          flexDirection: "row",
          width: "100%",
        }}
      >
        <div
          style={{
            flex: 1,
            textAlign: "right",
            cursor: "pointer",
            pointerEvents: "auto",
          }}
          onClick={() => {
            navigate("/cart")
          }}
        >
          View Cart <InfoCircle height={"1.3rem"} width={"1.3rem"} />
        </div>
      </div>
      <hr
        style={{
          backgroundColor: "#DEDEDE",
          height: 1,
          border: "none",
          borderColor: "#DEDEDE",
        }}
      />
    </React.Fragment>
  )
}

function HeaderBasket(props) {
  const [basketCount, setBasketCount] = useState()
  const wrapperRef = useRef(null)

  const { show, cart = [], type = "" } = props.cartPop

  useOutsideAlerter(wrapperRef, () => {
    if (props.hideCartPop) {
      props.hideCartPop()
    }
  })

  let userInfo = null
  const accessToken = inBrowser ? localStorage.getItem("access-token") : ""
  if (accessToken) {
    userInfo = decodeUserToken(accessToken)
  }

  const headers = {
    deviceId: deviceId,
  }

  const shoppingCart = useQuery(getShoppingCartQueryGQL, {
    fetchPolicy: "network-only",
  })

  const hasData =
    !shoppingCart.loading &&
    shoppingCart.data &&
    shoppingCart.data.getShoppingCart &&
    shoppingCart.data.getShoppingCart.itemCount > 0

  const shoppingCartItemsData = hasData
    ? shoppingCart.data.getShoppingCart.cartItems
    : []

  const getItemsForCheckout = _ => {
    var ids = []
    shoppingCartItemsData.map(item => {
      ids.push(item._id)
    })
    return ids
  }

  const cartItemsForGTM = _ => {
    var cartItemList = []
    shoppingCartItemsData.map(item => {
      cartItemList.push({
        name: item.name,
        id: item.sku,
        price: item.amount,
        brand: item.brandName,
        quantity: item.quantity,
      })
      return 0
    })
    return cartItemList
  }

  useEffect(() => {
    if (basketCount) {
      if (
        shoppingCart &&
        shoppingCart.data &&
        shoppingCart.data.getShoppingCart.itemCount &&
        basketCount != shoppingCart.data.getShoppingCart.itemCount &&
        window.location.pathname.indexOf("cart") < 0
      ) {
        setBasketCount(shoppingCart.data.getShoppingCart.itemCount)
      }
    } else {
      if (hasData) {
        setBasketCount(shoppingCart.data.getShoppingCart.itemCount)
      }
    }
  }, [shoppingCart.data, hasData])

  let message = `${cart.length} item${cart.length === 1 ? "" : "s"} `
  switch (type) {
    case "add": {
      message = message + "added to your cart"
      break
    }
    case "remove": {
      message = message + "removed from your cart"
      break
    }
    case "update": {
      message = "Updated " + message + " from your cart"
      break
    }
    default: {
      message = message + "added to your cart"
    }
  }

  return (
    <>
      <MainContainer>
        <HeaderButton onClick={() => navigate("/cart")}>
         {hasData && shoppingCart.data.getShoppingCart.itemCount > 0 && (
            <ShoppingCartCount hasData={hasData}>
              {hasData && shoppingCart.data.getShoppingCart.itemCount}
            </ShoppingCartCount>
          )}
          <ShoppingCart size={"2.2rem"} color={"#fff"} />
          <ShoppingCartSubtotal>
            P{hasData ? parseFloat(shoppingCart.data.getShoppingCart.subTotal).toFixed(2) : '0.00'}
          </ShoppingCartSubtotal>
        </HeaderButton>
      </MainContainer>
      <CartPopContainer show={show} ref={wrapperRef}>
        {/* {type === "add" && (
       <WebView>
         <TopPointer />
       </WebView>
     )} */}
        <CartPop>
          <TopMessage>
            <Message>
              <CheckAlt width={"20"} height={"20"} color={theme[APP_ID].redlabel} />
              <Spacer width={"1rem"} />
              <div>{message}</div>
            </Message>
            <CloseButton onClick={() => props.hideCartPop()}>
              <Close width={"30"} height={"30"} color={"#000"} />
            </CloseButton>
          </TopMessage>
          <Spacer height={"2rem"} />
          <NotificationDetails>
            <ItemCards>
              {cart.map((item, index) => {
                return (
                  <Item key={index}>
                    <NotificationCard
                      key={index}
                      cardImgSrc={item ? item.image : ""}
                      currentPrice={item ? item.currentPrice : 0}
                      quantity={item ? item.quantity : ""}
                      width="35%"
                      brandName={item ? item.brandName : ""}
                      productName={item ? item.productName : ""}
                      size={item ? item.size : ""}
                      rating={item ? item.rating : ""}
                      color={item ? item.color : ""}
                    />
                  </Item>
                )
              })}
            </ItemCards>
            {type === "add" && (
              <ButtonContainer>
                <Button>
                  <CartPopCheckout
                    hasShoppingCart={hasData}
                    getItemsForCheckout={getItemsForCheckout()}
                    cartItemsForGTM={cartItemsForGTM()}
                  />
                </Button>
                <Spacer height={"2rem"} />
                <Button>
                  <RoundedButton
                    width="100%"
                    primary
                    onClick={() => navigate("/cart")}
                  >
                    <ButtonText color={"#fff"}>View Cart</ButtonText>
                  </RoundedButton>
                </Button>
              </ButtonContainer>
            )}
          </NotificationDetails>
        </CartPop>
      </CartPopContainer>
    </>
  )
}

export default withApolloClient(HeaderBasket, { client: "b2bClient" })
